module.exports = __webpack_public_path__ + "media/images/font/Gustavo-ThinItalic-529557fae3446122c6efd4c2268b4359.woff2";